import { ELocalStorageKey } from '../types/enums'
import request, { IWorkspaceResponse } from '/@/api/http/request'
import { mapLayers } from '/@/constants/mock-layers'
import { elementGroupsReq, PostElementsBody, PutElementsBody } from '/@/types/mapLayer'
const PREFIX = '/map/api/v1'
const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
type UnknownResponse = Promise<IWorkspaceResponse<unknown>>
// get elements group
// export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
//   const url = `${PREFIX}/workspaces/${workspace_id}/element_groups`
//   const result = await request.get(url, {
//     params: {
//       group_id: reqParams.groupId,
//       is_distributed: reqParams.isDistributed
//     },
//   })
//   return result.data
// }
export const getLayers = async (reqParams: elementGroupsReq): UnknownResponse => {
  return mapLayers
}

// Get elements groups request
export const getElementGroupsReq = async (workspaceId: string, params: elementGroupsReq): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/element-groups`
  const result = await request.get(url, {
    params: params
  })
  return result.data
}
// add element
export const postElementsReq = async (workspaceId: string, pid: string, body: any): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/element-groups/${pid}/elements`
  const result = await request.post(url, body)
  return result.data
}
// delete element
export const deleteElementsReq = async (workspaceId: string, id: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/${id}`
  const result = await request.delete(url)
  return result.data
}
export const addRoi = async (body: object): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = '/manage/api/v1/roi/add'
  const result = await request.post(url, body)
  return result.data
}
export const updateRoi = async (body: object): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = '/manage/api/v1/roi/update'
  const result = await request.post(url, body)
  return result.data
}
export const listByFlyLineFileId = async (fly_line_file_id: string, workspace_id:string): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `/manage/api/v1/roi/listByFlyLineFileId/${fly_line_file_id}/${workspace_id}`
  const result = await request.post(url)
  return result.data
}
// Update map element request
export const updateElementsReq = async (workspaceId: string, id: string, body: any): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/${id}`
  const result = await request.put(url, body)
  return result.data
}

// Move a map element to another annotation group.
export const updateElementGroupReq = async (workspaceId: string, elementId: string, groupId: string, sortOrder?: number): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/${elementId}/group`
  const result = await request.put(url, {
    group_id: groupId,
    ...(sortOrder === undefined ? {} : { sort_order: sortOrder })
  })
  return result.data
}
// Delete map element
export const deleteElementReq = async (workspaceId: string, id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/${id}`
  const result = await request.delete(url, body)
  return result.data
}

// Delete layer elements
export const deleteLayerEleReq = async (workspaceId: string, id: string, body: {}): Promise<any> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/element-groups/${id}/elements`
  const result = await request.delete(url, body)
  return result.data
}

// Upload mark JSON
export const uploadMarkJson = async (workspaceId: string, body: any): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/uploadMarkJson`
  const result = await request.post(url, body)
  return result.data
}

export interface KmlImportResult {
  group_count: number
  element_count: number
  warnings: string[]
}

export const importKmlAnnotationsReq = async (workspaceId: string, file: File): Promise<IWorkspaceResponse<KmlImportResult>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/import/kml`
  const formData = new FormData()
  formData.append('file', file)
  const result = await request.post(url, formData)
  return result.data
}

export const exportKmlAnnotationsReq = async (workspaceId: string, groupId: string): Promise<{ blob: Blob, filename: string }> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/export/kml`
  const result = await request.get(url, {
    params: { group_id: groupId },
    responseType: 'blob'
  })
  const disposition = String(result.headers?.['content-disposition'] || '')
  const encodedFilename = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  const plainFilename = disposition.match(/filename="?([^";]+)"?/i)?.[1]
  let filename = 'KML导出.kml'
  try {
    if (encodedFilename) filename = decodeURIComponent(encodedFilename)
    else if (plainFilename) filename = plainFilename
  } catch (error) {
    filename = encodedFilename || plainFilename || filename
  }
  return { blob: result.data as Blob, filename }
}

// Get groups tree
export const getGroupsTreeReq = async (workspaceId: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/groups/tree`
  const result = await request.get(url)
  return result.data
}

// Add group
export const addGroupReq = async (workspaceId: string, body: any): Promise<IWorkspaceResponse<{ id: string }>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/groups`
  const result = await request.post(url, body)
  return result.data
}

// Update group
export const updateGroupReq = async (workspaceId: string, groupId: string, body: any): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/groups/${groupId}`
  const result = await request.put(url, body)
  return result.data
}

/** Move selected folders and annotations into one target folder atomically. */
export const moveTreeNodesReq = async (
  workspaceId: string,
  body: {
    group_ids?: string[],
    element_ids?: string[],
    target_group_id: string,
    target_element_id?: string,
    target_position?: 'before' | 'after'
  }
): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/tree/move`
  const result = await request.put(url, body)
  return result.data
}

// Delete group
export const deleteGroupReq = async (workspaceId: string, groupId: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/groups/${groupId}`
  const result = await request.delete(url)
  return result.data
}

// ================= 作业区域/禁飞区 (flight-area) =================

// 获取区域列表
export const getFlightAreasReq = async (workspaceId: string, params?: any): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/flight-areas`
  const result = await request.get(url, { params })
  return result.data
}

// 新增区域
export const addFlightAreaReq = async (workspaceId: string, body: any): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/flight-area`
  const result = await request.post(url, body)
  return result.data
}

// 更新区域
export const updateFlightAreaReq = async (workspaceId: string, areaId: string, body: any): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/flight-area/${areaId}`
  const result = await request.put(url, body)
  return result.data
}

// 删除区域
export const deleteFlightAreaReq = async (workspaceId: string, areaId: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/flight-area/${areaId}`
  const result = await request.delete(url)
  return result.data
}

// 同步到机场
export const syncFlightAreaReq = async (workspaceId: string): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/flight-area/sync`
  const result = await request.post(url)
  return result.data
}

// Update element display status
export const updateElementDisplayReq = async (workspaceId: string, elementId: string, body: { display: number }): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/elements/${elementId}/display`
  const result = await request.put(url, body)
  return result.data
}

// Update group elements display status
export const updateGroupElementsDisplayReq = async (workspaceId: string, groupId: string, body: { display: number }): Promise<IWorkspaceResponse<any>> => {
  const url = `${PREFIX}/workspaces/${workspaceId}/element-groups/${groupId}/elements/display`
  const result = await request.put(url, body)
  return result.data
}
